/* eslint-disable global-require,import/no-unresolved,react/destructuring-assignment,react/prop-types */
import React, { Component } from 'react'
import { ScrollView, Text, View } from 'react-native'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next'
import styles, { colors } from '../../styles'
import SimpleMenuListItem from '../subcomponents/SimpleMenuListItem'
import * as tapEvents from '../../actions/tapEvents'
import { getCountryCodeFromLocale, getLanguageCodeFromLocale } from '../../utils'
import * as RegionalContentLookup from '../methods/RegionalContentLookUp'
import listMenuItemStyles from '../../styles/listMenuItem'

const COVID_STUDY_INCLUDED_MONITORING_STATUSES = ['Monitored', 'Not Monitored']
const COVID_STUDY_INCLUDED_COUNTRIES = ['US', 'GU', 'PR', 'MP', 'AS', 'VI', 'UM']
const COVID_STUDY_INCLUDED_LANGUAGES = ['en', 'es']

const BSC_RESEARCH_INCLUDED_COUNTRIES = ['US', 'GU', 'PR', 'MP', 'AS', 'VI', 'UM']
const BSC_RESEARCH_INCLUDED_LANGUAGES = ['en']

class FAQBSCPage extends Component {
  tapFAQItem = async (title, id) => {
    this.props.faqItemTapped(title, id)
  }

  render() {
    const { t } = this.props
    return (
      <View accessibilityLabel={t('access:faqBSCPage')} testID="view-FAQListPage" style={[styles.container, { backgroundColor: colors.raven_grey10 }]}>
        <ScrollView
          testID="scrollview-FAQBSCPage"
        >
          <View style={{
            flex: 1, flexDirection: 'column', alignItems: 'center',
          }}
          >
            <Text style={listMenuItemStyles.sectionTextHeader}>
              {t('aboutBSCI')}
            </Text>
          </View>
          <SimpleMenuListItem
            t={t}
            titleKey="faq:whoIsBostonScientific"
            testID="faqbtn-who-bsc"
            onPress={() => this.tapFAQItem('whoIsBostonScientific', 'whoBsc')}
          />
          {this.getCovidStudy()}
          {this.getBSCResearch()}
        </ScrollView>
      </View>
    )
  }

  getCovidStudy() {
    const {
      t, locale, monitoringStatus, underage,
    } = this.props
    const lang = getLanguageCodeFromLocale(locale)
    const country = getCountryCodeFromLocale(locale)
    if (COVID_STUDY_INCLUDED_COUNTRIES.includes(country)
      && COVID_STUDY_INCLUDED_LANGUAGES.includes(lang)
      && COVID_STUDY_INCLUDED_MONITORING_STATUSES.includes(monitoringStatus)
      && !underage) {
      return (
        <>
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="covidNoticeDetailTitle"
            testID="faqbtn-covid19StudyFaq"
            onPress={() => this.tapFAQItem('covidNoticeDetailTitle', 'covidStudy')}
          />
        </>
      )
    }
    return null
  }

  getBSCResearch() {
    const { t, locale } = this.props
    const lang = getLanguageCodeFromLocale(locale)
    const country = getCountryCodeFromLocale(locale)
    if (BSC_RESEARCH_INCLUDED_COUNTRIES.includes(country)
      && BSC_RESEARCH_INCLUDED_LANGUAGES.includes(lang)) {
      return (
        <>
          <View style={styles.lightSeparator} />
          <SimpleMenuListItem
            t={t}
            titleKey="feedbackResearchTitle"
            testID="faqbtn-bscResearchFaq"
            onPress={() => this.tapFAQItem('bscResearchTitle', 'bscResearch')}
          />
        </>
      )
    }
    return null
  }
}

FAQBSCPage.propTypes = {
  faqItemTapped: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  locale: PropTypes.string.isRequired,
  monitoringStatus: PropTypes.string,
  underage: PropTypes.bool,
}

FAQBSCPage.defaultProps = {
  monitoringStatus: null,
  underage: true,
}

const actionCreators = {
  faqItemTapped: tapEvents.faqItemTapped,
  regionalContentLookup: RegionalContentLookup.regionalContentLookup,
}

const mapStateToProps = (state) => {
  const { storedData } = state
  return {
    locale: storedData.locale,
    currentModelNumber: storedData.deviceModel,
    monitoringStatus: storedData.monitoringStatus,
    underage: storedData.underage,
  }
}

export const FAQBSCPageComponent = FAQBSCPage

export default withTranslation(['faq', 'common'])(connect(mapStateToProps, actionCreators)(FAQBSCPage))
